import { render, staticRenderFns } from "./discrepancy-resolution.vue?vue&type=template&id=e8f1c572&"
import script from "./js/discrepancy-resolution.js?vue&type=script&lang=js&"
export * from "./js/discrepancy-resolution.js?vue&type=script&lang=js&"
import style0 from "./discrepancy-resolution.vue?vue&type=style&index=0&id=e8f1c572&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports